// extracted by mini-css-extract-plugin
export default {"card":"d1-z","carouselContainer":"e1-z","carouselContent":"f1-z"};